import { render, staticRenderFns } from "./PagePart5_edit.vue?vue&type=template&id=c5dc3668&scoped=true"
import script from "./PagePart5_edit.vue?vue&type=script&lang=js"
export * from "./PagePart5_edit.vue?vue&type=script&lang=js"
import style0 from "./PagePart5_edit.vue?vue&type=style&index=0&id=c5dc3668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5dc3668",
  null
  
)

export default component.exports